/*
 * Get-delivery-orders.ts
 * Description: Includes the declaration
 * of the function for getting a list of delivery orders
 */

// Importing Axios for HTTP request
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing Vuex store
import {store} from '@/config/plugins';

/**
 * Getting delivery orders
 *
 * @return {Object} Promise - list of orders for delivery
 */
export function getDeliveryOrders() {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        // Using Axios to send the request
        Axios({
            url: APIURL + 'deliveries',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            // Assigning the data array to users
            store.dispatch('setResponse', response.data.data);
            store.dispatch('setLastPage', response.data.meta.last_page);
            resolve();
        }).catch((error) => {
            reject();
        });
    });
}
